const Config = {
  'Prd.main.list': {
    operation: ['VISIBLE'],
    title: '列表',
    c: {
      type: 'constant',
      value: 'list',
    },
    getParse_productdetail: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { pageName, traceObj } = args;
        const { tabIndex = 0 } = traceObj;
        if (item.item && item.index !== null) {
          // console.log('========商品曝光', JSON.stringify(item?.item?.viewType));
          const result = [
            {
              type: 'productdetail',
              item: item?.item,
              isViewable: item.isViewable,
              key: item.key,
              index: item?.index,
              page: pageName,
              b: pageName,
              c: 'tour',
              d: item.item.statKey,
              iid: 'type=' + item?.item?.viewType,
            },
          ];
          return result;
        }
        return [];
      },
    },
    getParse_comment: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        // alert(JSON.stringify(item));
        const { pageName } = args;
        const res = [];
        if (item?.item?.type === 'comment') {
          // todo
          if (item.item.askAll) {
            res.push({
              type: 'question',
              isViewable: item.isViewable,
              key: 'question',
              index: 0,
              page: pageName,
              b: pageName,
              c: 'question',
              d: 1,
            });
          }
          if (item.item.buyerShow) {
            res.push({
              type: 'review',
              isViewable: item.isViewable,
              key: 'review',
              index: 0,
              page: pageName,
              b: pageName,
              c: 'review',
              d: 1,
            });
          }
          if (item.item.evaluate) {
            res.push({
              type: 'articles',
              isViewable: true,
              key: 'articles',
              index: 0,
              page: pageName,
              b: pageName,
              c: 'articles',
              d: 1,
            });
            if (item.item.evaluate?.length < 3) {
              (item.item.evaluate || []).forEach((i, index) => {
                const data = {
                  type: 'article',
                  isViewable: true,
                  key: 'article' + index,
                  index: index,
                  page: pageName,
                  b: pageName,
                  c: 'article',
                  d: index + 1,
                };
                try {
                  const extra = JSON.parse(i.action.extra);
                  data.iid = `next=article.${extra?.article_id}`;
                } catch (e) {}
                res.push(data);
              });
            }
          }
        }
        return res;
      },
    },
    getParse_recommend: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { pageName } = args;
        const result = [
          {
            type: 'recommend',
            item: item?.item?.[0],
            isViewable: item.isViewable,
            key: item.key,
            index: item?.index,
            page: pageName,
            b: pageName,
            c: 'feed',
            d: item?.item?.currentIndex,
            iid: `next=product.${item?.item?.[0]?.data?.goods?.itemId}&u=${encodeURIComponent(
              'https://m.mi.com/mfbs/mstd/product?commodityId=' + item?.item?.[0]?.data?.goods?.itemId,
            )}`,
            scmv2: item?.item?.[0]?.scmv2,
          },
          {
            type: 'recommend',
            item: item?.item?.[1],
            isViewable: item.isViewable,
            key: item.key,
            index: item?.index,
            page: pageName,
            b: pageName,
            c: 'feed',
            d: item?.item?.currentIndex,
            iid: `next=product.${item?.item?.[1]?.data?.goods?.itemId}&u=${encodeURIComponent(
              'https://m.mi.com/mfbs/mstd/product?commodityId=' + item?.item?.[1]?.data?.goods?.itemId,
            )}`,
            scmv2: item?.item?.[1]?.scmv2,
          },
          {
            type: 'recommend',
            item: item?.item?.[0],
            isViewable: item.isViewable,
            key: item.key,
            index: item?.index,
            page: pageName,
            b: pageName,
            c: 'similar',
            d: item?.item?.currentIndex,
            iid: `next=product.${item?.item?.[0]?.data?.goods?.itemId}&u=${encodeURIComponent(
              item?.item?.similarityUrl || '',
            )}`,
            scmv2: item?.item?.[0]?.scmv2,
          },
          {
            type: 'recommend',
            item: item?.item?.[1],
            isViewable: item.isViewable,
            key: item.key,
            index: item?.index,
            page: pageName,
            b: pageName,
            c: 'similar',
            d: item?.item?.currentIndex,
            iid: `next=product.${item?.item?.[1]?.data?.goods?.itemId}&u=${encodeURIComponent(
              item?.item?.similarityUrl || '',
            )}`,
            scmv2: item?.item?.[1]?.scmv2,
          },
        ];
        return result;
      },
    },
    getParse: {
      type: 'variable',
      func: function () {
        return [];
      },
    },
  },

  'Prd.comment.evaluate': {
    operation: ['VISIBLE'],
    title: '列表',
    c: {
      type: 'constant',
      value: 'list',
    },
    getParse: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { pageName } = args;
        const res = [];
        const data = {
          type: 'article',
          isViewable: item.isViewable,
          key: 'article' + item.index,
          index: item.index,
          page: pageName,
          b: pageName,
          c: 'article',
          d: item.index + 1,
        };
        try {
          const extra = JSON.parse(item.item.action.extra);
          data.iid = `next=article.${extra?.article_id}`;
        } catch (e) {}
        res.push(data);
        return res;
      },
    },
  },
  'Prd.store.list': {
    operation: ['VISIBLE'],
    title: '列表',
    c: {
      type: 'constant',
      value: 'list',
    },
    getParse: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { pageName, traceObj } = args;
        const res = [];
        if (item?.item?.orgId) {
          ['store_chosse', 'store_wechat', 'store_phone'].forEach((key) => {
            res.push({
              type: key,
              isViewable: item.isViewable,
              key: key + item.index,
              index: item.index,
              page: pageName,
              b: pageName,
              c: key,
              d: item.index + 1,
            });
          });
          res.push({
            type: 'sheet',
            isViewable: item.isViewable,
            key: 'sheet' + item.index,
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'sheet',
            d: item?.item?.d,
            iid: `org_id=${item?.item?.orgId || ''}&store_id=${traceObj?.selectedNearStoreId}&store_conditions=${
              traceObj?.currentTab === 'near' ? 1 : 2
            }${item?.item?.freqBoughtStore ? '&often_buy=true' : ''}`,
          });
        }
        return res;
      },
    },
  },
  'Prd.nav.back': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '返回',
    c: {
      type: 'constant',
      value: 'back',
    },
  },
  'Prd.nav.share': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '分享',
    c: {
      type: 'constant',
      value: 'share',
    },
  },
  'Prd.nav.share.popup': {
    operation: ['TOUCH'],
    title: '分享弹层&分享海报下载',
    c: {
      type: 'variable',
      func: function getD(traceData) {
        let c = 'sheet_share';
        switch (traceData.type) {
          case 'download_poster':
            c = 'snapshot';
            break;
          default:
            c = 'sheet_share';
        }
        return c;
      },
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        let d = 1;
        switch (traceData.type) {
          case 'wechat_friend':
            d = 1;
            break;
          case 'wechat_moments':
            d = 2;
            break;
          case 'weibo':
            d = 3;
            break;
          case 'qq_friend':
            d = 4;
            break;
          case 'qq_moments':
            d = 5;
            break;
          case 'copy_link':
            d = 6;
            break;
          case 'download_poster':
            d = 7;
            break;
          case 'cancel':
            d = 10000;
            break;
          default:
            d = 10000;
        }
        return d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        if (traceData.type == 'download_poster') {
          return null;
        }
        return 'tag=' + traceData.type + '&u=' + traceData.shortLink;
      },
    },
  },
  'Prd.nav.more': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '更多',
    c: {
      type: 'constant',
      value: 'menu',
    },
  },
  'Prd.nav.more.popup': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '更多弹层',
    c: {
      type: 'variable',
      func: function getD(traceData) {
        let c = 'home';
        switch (traceData.index) {
          case 1:
            c = 'home';
            break;
          case 2:
            c = 'message';
            break;
          case 3:
            c = 'favor';
            break;
          default:
            c = '';
        }
        return c;
      },
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return 1;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return 'u=' + traceData.url;
      },
    },
  },
  'Prd.live': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '悬浮直播',
    c: {
      type: 'constant',
      value: 'livestream',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return 'roomid=' + traceData.roomId;
      },
    },
  },
  'Prd.ads': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '悬浮广告',
    c: {
      type: 'constant',
      value: 'clipstream',
    },
  },
  'Prd.3d.click': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '3D探索按钮',
    c: {
      type: 'constant',
      value: '3D',
    },
  },
  'Prd.eye_3d': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '环景3D',
    c: {
      type: 'constant',
      value: '3d_animation',
    },
  },
  'Prd.eye_3d.explore': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '环景3D探索按钮',
    c: {
      type: 'constant',
      value: 'adventure',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return 'url=' + traceData?.url;
      },
    },
  },
  'Prd.carousel': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '产品站轮播图',
    c: {
      type: 'constant',
      value: 'carousel',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.index + 1;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return 'type=' + traceData.type;
      },
    },
  },
  // 头图bar
  'Prd.carousel.tab': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '轮播图的tab',
    c: {
      type: 'constant',
      value: 'shortcut',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        if (traceData.item.type == 'sence') {
          return 10000;
        }
        return traceData.index + 1;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return 'tag=' + traceData.item.name;
      },
    },
  },
  'Prd.discount': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '降价提醒',
    c: {
      type: 'constant',
      value: 'markdown',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return 'status=' + traceData.status;
      },
    },
  },
  'Prd.ranking': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '榜单',
    c: {
      type: 'constant',
      value: 'ranking',
    },
  },
  'Prd.buyAssist.modelCompare': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '帮你挑/选购指南&机型对比',
    c: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData == 'buying_guide' ? 'choose' : 'compare';
      },
    },
  },
  'Prd.core.param': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '核心参数',
    c: {
      type: 'constant',
      value: 'spec',
    },
  },
  'Prd.up.tab': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '产品站顶部tab',
    c: {
      type: 'constant',
      value: 'tab',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.index + 1;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return 'tag=' + traceData.title;
      },
    },
  },
  'Prd.back.top': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '悬浮置顶',
    c: {
      type: 'constant',
      value: 'top',
    },
  },
  'Prd.scene.buy': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '场景_搭配购买',
    c: {
      type: 'constant',
      value: 'makeup',
    },
    iid: {
      type: 'variable',
      func: function getIid() {
        return 'type=' + 'mijia';
      },
    },
  },
  'Prd.scene.goods': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '场景_热区商品',
    c: {
      type: 'constant',
      value: 'product',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.index + 1;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return 'next=' + traceData.url + '&type=' + 'mijia';
      },
    },
  },
  'Prd.scene.pop.goods': {
    operation: ['TOUCH'],
    title: '场景_组合购买弹层_商品',
    c: {
      type: 'constant',
      value: 'product',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.index + 1;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return 'next=' + traceData.url + '&type=' + 'sheet_mijia';
      },
    },
  },
  'Prd.scene.pop.list': {
    operation: ['VISIBLE'],
    title: '场景_组合购买弹层_商品',
    getParse: {
      type: 'variable',
      func(item, data, { pageName }) {
        return [
          {
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            d: item.index + 1,
            c: 'product',
          },
        ];
      },
    },
  },

  'Prd.scene.pop.checkall': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '场景_组合购买弹层_全选',
    c: {
      type: 'constant',
      value: 'selectall',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return 'status=' + traceData.status;
      },
    },
  },
  'Prd.scene.pop.addcart': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '场景_组合购买弹层_加购',
    c: {
      type: 'constant',
      value: 'addcart',
    },
    iid: {
      type: 'variable',
      func: function getIid() {
        return 'type=' + 'sheet_mijia';
      },
    },
  },
  'Prd.scene.pop.buy': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '场景_组合购买弹层_购买',
    c: {
      type: 'constant',
      value: 'purchase',
    },
    iid: {
      type: 'variable',
      func: function getIid() {
        return 'type=' + 'sheet_mijia';
      },
    },
  },
  'Prd.detail': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '商品详情tab',
    c: {
      type: 'constant',
      value: 'tour',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.index + 1;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return 'tag=' + traceData.tabName;
      },
    },
  },
  'Prd.detail.items': {
    operation: ['TOUCH'],
    title: '商品详情_楼层_点击',
    c: {
      type: 'constant',
      value: 'tour',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData?.tabIndex * 10000 + traceData.index + 1;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return 'type=' + traceData.type;
      },
    },
  },
  'Prd.detail.point': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '商品详情_锚点_2展开_1合并',
    c: {
      type: 'constant',
      value: 'anchor',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        if (traceData.status == 1) {
          return 10000;
        }
        return traceData.index + 1;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        if (traceData.status == 1) {
          return 'status=' + 1;
        }
        return 'tag=' + traceData.tag + '&status=' + 2;
      },
    },
  },
  'Prd.newuser.banner': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '新人banner',
    c: {
      type: 'constant',
      value: 'newbie',
    },
  },
  // 会员banner
  'Prd.friend.banner': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '会员banner',
    c: {
      type: 'constant',
      value: 'friend',
    },
    iid: {
      type: 'variable',
      func: ({ type, status }) => {
        return `type=${type}${type === '0' ? '' : `&status=${status}`}`;
      },
    },
  },
  'Prd.discount.promotion': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '优惠栏',
    c: {
      type: 'constant',
      value: 'promote',
    },
    iid: {
      type: 'variable',
      func: ({ disCountList = [] }) => {
        let hasFCoin = false;
        let cardType = null;
        let abTest = null;
        const list = [];
        disCountList.forEach((item) => {
          if (item?.type == 'promotion_coin' && item?.tags?.includes('fCoin')) {
            hasFCoin = true;
          }
          if (!cardType && Array.isArray(item?.tags)) {
            cardType = item?.tags?.find((tag) => {
              return ['consumables_card', 'wearable_card', 'service_card'].includes(tag);
            });
          }
          //  添加abTest埋点
          if (!abTest && item?.abTest && item.abTest?.testId && item.abTest?.groupId) {
            abTest = item.abTest;
            list.push(`test_id=${abTest.testId}`, `group_id=${abTest.groupId}`);
          }
        });
        // 钻石卡埋点
        if (cardType) {
          list.push(`card_type=${cardType}`);
        }
        if (hasFCoin) {
          list.push(`activity_type="返米金"`);
        }
        return list.join('&');
      },
    },
  },
  'Prd.discount.subsidy': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '优惠栏弹层国补优惠',
    c: {
      type: 'constant',
      value: 'country_activity',
    },
    iid: {
      type: 'variable',
      func: ({ type, regionId, fetchType, url, activity_id }) => {
        const params = [
          `type=${type}`,
          regionId ? `activity_id=${regionId}` : '',
          fetchType ? `activity_type=${fetchType}` : '',
          url ? `u=${url}` : '',
          activity_id ? `activity_id=${activity_id}` : '',
        ]
          .filter(Boolean)
          .join('&');
        return params;
      },
    },
  },
  'Prd.discountpop.rule': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '优惠弹层规则说明',
    c: {
      type: 'constant',
      value: 'rule_explain',
    },
  },
  'Prd.service.choose': {
    operation: ['TOUCH'],
    title: '已选',
    c: {
      type: 'constant',
      value: 'select',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { curGidInfo, services, selectCount, curPidInfo, batchedInfo } = traceData;
        let bundle_sku = [];
        if (curPidInfo.batched) {
          const items = batchedInfo?.batchedList;

          bundle_sku = items?.map((i) => {
            const subItem = i.goods[0];
            return {
              product_id: subItem?.productId,
              goodsId: subItem?.goodsId,
            };
          });
        }
        const skus = [
          {
            count: selectCount,
            batched: !!curPidInfo.batched,
            product_id: curGidInfo.productId,
            goods_id: curGidInfo.goodsId,
            service_type_list: (services || []).map((item) => {
              return {
                service_list: [
                  {
                    service_goods_id: item.id,
                    service_sku: item.serviceSku,
                  },
                ],
              };
            }),
            bundle_sku,
          },
        ];
        return `skus=${encodeURIComponent(JSON.stringify(skus))}`;
      },
    },
  },
  'Prd.service.deliver': {
    operation: ['TOUCH'],
    title: '送至',
    c: {
      type: 'constant',
      value: 'deliver',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { address, deliveryData } = traceData;
        const statusMap = {
          有现货: '1',
          库存紧张: '2',
          该地区暂时缺货: '0',
          暂时缺货: '0',
        };
        return `address=${encodeURIComponent(JSON.stringify(address))}&status=${
          statusMap[deliveryData?.datas?.stockStatus] || '3'
        }`;
      },
    },
  },
  'Prd.compensation': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'comp', // C 位 ID
    },
    d: {
      type: 'constant',
      value: 1, // 将 d 位设置为 1
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        const typeArray = traceData.type || [];
        return 'type=' + encodeURIComponent(JSON.stringify(typeArray));
      },
    },
  },
  'Prd.compensation.sub_touch': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'delivery_label', // C 位 ID
    },
    d: {
      type: 'constant',
      value: 1, // 将 d 位设置为 1
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        const map = {
          DISPATCH_TODAY: 3,
          DISPATCH_TOMORROW: 4,
          ARRIVAL_TODAY: 1,
          ARRIVAL_TOMORROW: 2,
        };
        const { bestTag, curGidInfo } = traceData;
        const skus = [
          {
            ssuId: curGidInfo?.productId,
            itemId: curGidInfo?.goodsId,
            count: '1',
          },
        ];
        return `type=${map[bestTag] || 0}&skus=${encodeURIComponent(JSON.stringify(skus))}`;
      },
    },
  },
  'Prd.compensation.sub_visible': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'delivery_label', // C 位 ID
    },
    d: {
      type: 'constant',
      value: 1, // 将 d 位设置为 1
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        const map = {
          DISPATCH_TODAY: 3,
          DISPATCH_TOMORROW: 4,
          ARRIVAL_TODAY: 1,
          ARRIVAL_TOMORROW: 2,
        };
        const { bestTag, curGidInfo } = traceData;
        const skus = [
          {
            ssuId: curGidInfo?.productId,
            itemId: curGidInfo?.goodsId,
            count: '1',
          },
        ];
        return `type=${map[bestTag] || 0}&skus=${encodeURIComponent(JSON.stringify(skus))}`;
      },
    },
  },
  'Prd.delivery.text': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'delivery_time', // C 位 ID
    },
    d: {
      type: 'constant',
      value: 1, // 将 d 位设置为 1
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        const map = {
          DISPATCH_TODAY: 3,
          DISPATCH_TOMORROW: 4,
          ARRIVAL_TODAY: 1,
          ARRIVAL_TOMORROW: 2,
        };
        const { bestTag, curGidInfo } = traceData;
        const skus = [
          {
            ssuId: curGidInfo?.productId,
            itemId: curGidInfo?.goodsId,
            count: '1',
          },
        ];
        return `type=${map[bestTag] || 0}&skus=${encodeURIComponent(JSON.stringify(skus))}`;
      },
    },
  },

  'Prd.compensation_popup': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'comp_popup', // C 位 ID
    },
    d: {
      type: 'constant',
      value: 2, // 将 d 位设置为 2
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        const typeArray = traceData.type || [];
        return 'type=' + encodeURIComponent(JSON.stringify(typeArray));
      },
    },
  },
  'Prd.sku.deliveryTime_sub': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'specification_delivery_time', // C 位 ID
    },
    d: {
      type: 'constant',
      value: 1, // 将 d 位设置为 2
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        const map = {
          DISPATCH_TODAY: 3,
          DISPATCH_TOMORROW: 4,
          ARRIVAL_TODAY: 1,
          ARRIVAL_TOMORROW: 2,
        };
        const { bestTag, curGidInfo } = traceData;
        const skus = [
          {
            ssuId: curGidInfo?.productId,
            itemId: curGidInfo?.goodsId,
            count: '1',
          },
        ];
        return `type=${map[bestTag] || 0}&skus=${encodeURIComponent(JSON.stringify(skus))}`;
      },
    },
  },
  'Prd.service.disaster_alert': {
    operation: ['VISIBLE'],
    title: '灾害提醒',
    c: {
      type: 'constant',
      value: 'disaster_alert',
    },
  },
  'Prd.service.offline_store': {
    operation: ['TOUCH'],
    title: '门店',
    c: {
      type: 'constant',
      value: 'offline_store',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const store = traceData.store;
        if (!store) {
          return;
        }
        const value = [store.canOnlineTrade ? 'off_line' : '', store?.storeFlash?.enable ? 'flash' : '']
          .filter(Boolean)
          .join('&');
        const status = {
          stock_enough: 1,
          stock_will_cos: 2,
          stock_is_cos: 0,
        };
        return `delivery_type=${encodeURIComponent(value)}&status=${
          status[store?.stockStatus] !== undefined ? status[store?.stockStatus] : '3'
        }`;
      },
    },
  },
  'Prd.service.service': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '服务',
    c: {
      type: 'constant',
      value: 'service',
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        const { supportCompensationForDamage, supportCompensationForNoDoor } = traceData || {};
        const map = {
          1: 'package_damage',
          2: 'on_site',
          3: 'package_damage&on_site',
        };
        let type = '';
        if (supportCompensationForDamage && supportCompensationForNoDoor) {
          type = '3';
        } else if (supportCompensationForDamage) {
          type = '1';
        } else if (supportCompensationForNoDoor) {
          type = '2';
        }
        const result = ['1', '2', '3'].includes(type) ? `compensation=${encodeURIComponent(map[type])}` : '';
        return result;
      },
    },
  },
  'Prd.service.specification_find_pic': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '图片查看',
    c: {
      type: 'constant',
      value: 'specification_find_pic',
    },
  },
  'Prd.service.specification_find_pic2': {
    operation: ['TOUCH'],
    title: '图片查看',
    c: {
      type: 'constant',
      value: 'specification_find_pic',
    },
  },
  'Prd.service.specification_pay_method': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '购买方式',
    c: {
      type: 'constant',
      value: 'specification_pay_method',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
  },
  'Prd.service.specification_delivery': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '配送方式',
    c: {
      type: 'constant',
      value: 'specification_delivery',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d + 1;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { item } = traceData;
        const type = {
          depot: 'online',
          store_flash: 'flash',
          store_pickup: 'off_line',
        };
        return `delivery_type=${type[item.type]}`;
      },
    },
  },
  'Prd.service.specification_flash_location': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '商城闪送_添加定位',
    c: {
      type: 'constant',
      value: 'specification_flash_location',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { url } = traceData;
        return `u=${encodeURIComponent(url)}`;
      },
    },
  },
  'Prd.service.specification_flash_store': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '商城闪送_切换门店',
    c: {
      type: 'constant',
      value: 'specification_flash_store',
    },
  },
  'Prd.service.specification_installment': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '分期方式',
    c: {
      type: 'constant',
      value: 'specification_installment',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d + 1;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { item } = traceData;
        // 元闪付分期的参数需要手动修改一下
        return `installment_type=${item.bank === 'UPQUICKPASS' ? 'cloud_quickpass' : item.bank}`;
      },
    },
  },
  // 'Prd.service.specification_installment': {
  //   operation: ['VISIBLE', 'TOUCH'],
  //   title: '分期方式',
  //   c: {
  //     type: 'constant',
  //     value: 'specification_installment',
  //   },
  // },
  'Prd.service.store_adress': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '门店弹层_切换地址',
    c: {
      type: 'constant',
      value: 'store_adress',
    },
  },
  'Prd.service.store_chosse': {
    operation: ['TOUCH'],
    title: '门店弹层_选中门店',
    c: {
      type: 'constant',
      value: 'sheet',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        const { store, selectedNearStoreId, currentTab, oftenBuy } = traceData;
        return `store_id=${store.orgId}&store_id=${selectedNearStoreId}&store_conditions=${
          currentTab === 'near' ? '1' : '2'
        }${oftenBuy ? '&often_buy=true' : ''}`;
      },
    },
  },
  'Prd.service.store_wechat': {
    operation: ['TOUCH'],
    title: '门店弹层_微信',
    c: {
      type: 'constant',
      value: 'store_wechat',
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        const { store } = traceData;
        return `store_id=${store.orgId}`;
      },
    },
  },
  'Prd.service.store_phone': {
    operation: ['TOUCH'],
    title: '门店弹层_电话',
    c: {
      type: 'constant',
      value: 'store_phone',
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        const { store } = traceData;
        return `store_id=${store.orgId}`;
      },
    },
  },
  'Prd.service.adress_edit': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '地址弹层_编辑',
    c: {
      type: 'constant',
      value: 'adress_edit',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.index + 1;
      },
    },
  },
  'Prd.service.adress_add': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '地址弹层_新增',
    c: {
      type: 'constant',
      value: 'adress_add',
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        const { url } = traceData;
        return `u=${encodeURIComponent(url)}`;
      },
    },
  },
  'Prd.service.staff_contact': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '店员弹层_联系',
    c: {
      type: 'constant',
      value: 'staff_contact',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d + 1;
      },
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        const { store, staff } = traceData;
        return `store=${store?.orgId}&staff_id=${staff?.encryptMid}`;
      },
    },
  },
  'Prd.service.service_pop': {
    operation: ['VISIBLE'],
    title: '店员弹层_联系',
    c: {
      type: 'constant',
      value: 'service_pop',
    },
  },
  'Prd.service.compensation_damage': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '包装破损赔',
    c: {
      type: 'constant',
      value: 'service_pop',
    },
    iid: {
      type: 'variable',
      func: () => {
        return 'compensation=package_damage';
      },
    },
  },
  'Prd.service.compensation_nodoor': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '不上门赔',
    c: {
      type: 'constant',
      value: 'service_pop',
    },
    iid: {
      type: 'variable',
      func: () => {
        return 'compensation=on_site';
      },
    },
  },

  'Prd.service.specification_online': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '商城配送_切换地址',
    c: {
      type: 'constant',
      value: 'specification_online',
    },
  },
  'Prd.service.specification_online_add': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '商城配送_填写地址',
    c: {
      type: 'constant',
      value: 'specification_online_add',
    },
  },

  'Prd.service.specification_offline_store': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '到店自取_切换门店',
    c: {
      type: 'constant',
      value: 'specification_offline_store',
    },
  },
  'Prd.service.buyer_show': {
    operation: ['TOUCH'],
    title: '买家秀',
    c: {
      type: 'constant',
      value: 'review',
    },
  },
  'Prd.service.answer': {
    operation: ['TOUCH'],
    title: '问答',
    c: {
      type: 'constant',
      value: 'question',
    },
  },
  'Prd.service.appraise': {
    operation: ['TOUCH'],
    title: '测评',
    c: {
      type: 'constant',
      value: 'articles',
    },
  },
  'Prd.service.acitve_exchange': {
    operation: ['TOUCH'],
    title: '测评文章',
    c: {
      type: 'constant',
      value: 'article',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d + 1;
      },
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        const { item } = traceData;
        try {
          const extra = JSON.parse(item.action.extra);
          return `next=article.${extra?.article_id}`;
        } catch (e) {
          return `next=article.`;
        }
      },
    },
  },
  'Prd.service.service1': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '客服',
    c: {
      type: 'constant',
      value: 'support',
    },
  },
  'Prd.service.favor': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '收藏',
    c: {
      type: 'constant',
      value: 'addfavor',
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        return `status=${traceData}`;
      },
    },
  },
  'Prd.service.cart': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '购物车',
    c: {
      type: 'constant',
      value: 'cart',
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        const { url } = traceData;
        return `u=${encodeURIComponent(url)}`;
      },
    },
  },
  'Prd.service.add_cart': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '加购btn',
    c: {
      type: 'constant',
      value: 'addcart',
    },
  },
  'Prd.service.buy': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '立即购买btn',
    c: {
      type: 'constant',
      value: 'purchase',
    },
  },
  'Prd.service.bottom_button': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '其他btn',
    c: {
      type: 'constant',
      value: 'btn',
    },
  },
  // 'Prd.service.appraise': {
  //   operation: ['VISIBLE', 'TOUCH'],
  //   title: '测评',
  //   c: {
  //     type: 'constant',
  //     value: 'appraise',
  //   },
  // },
  'Prd.discount.modal': {
    operation: ['VISIBLE'],
    title: '优惠弹窗',
    getParse_coin: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { pageName } = args;
        const result = [
          {
            type: 'coin',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'point_prompt',
            d: 1,
          },
        ];
        return result;
      },
    },
    getParse_gift: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        if (item?.item?.data) {
          return;
        }
        const { pageName } = args;
        let u;
        if (item?.item?.customRuleDetails?.length) {
          u = `https://m.mi.com/mfbs/mstd/joinmore?activity_id=${item?.item?.actId}`;
        } else if (item?.item?.selectInfo?.length === 1) {
          u = `https://m.mi.com/mfbs/mstd/product?goodsId=${item?.item?.selectInfo?.[0]?.goodsId}&commodityId=${item?.item?.selectInfo?.[0]?.productId}`;
        } else if (item?.item?.selectInfo?.length > 1) {
          const temp = [];
          item?.item?.selectInfo?.forEach((i) => {
            temp.push({
              u: `https://m.mi.com/mfbs/mstd/product?goodsId=${i?.goodsId}&commodityId=${i?.productId}`,
              pid: i?.productId,
            });
          });
          u = temp;
        } else if (
          !item?.item?.selectInfo &&
          item?.item?.typeDesc === '满赠' &&
          item?.item?.actGroups?.groups?.length > 1
        ) {
          u = `https://m.mi.com/mfbs/mstd/joinmore?activity_id=${item?.item?.actId}`;
        }
        let result;
        const platformMap = {
          onlineShop: ['online', '线上'],
          offlineStore: ['offlineStore', '线下'],
          commonShop: [encodeURIComponent('online&offlineStore'), '线上线下'],
        };
        if (typeof u === 'string') {
          result = [
            {
              type: 'gift',
              item: item.item,
              isViewable: item.isViewable,
              key: item.key,
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'promotion_activity',
              d: item?.item?.curIndex,
              iid: `activity_type=${item?.item?.typeDesc}&type=${platformMap[item?.item?.platform]?.[1]}&channel=${
                platformMap[item?.item?.platform]?.[0]
              }&activity_id=${item?.item?.actId || ''}&group_id=${item?.item?.groupId}&next=product.${
                item?.item?.selectInfo?.[0]?.productId || 0
              }&u=${encodeURIComponent(u)}`,
            },
          ];
        } else if (Array.isArray(u)) {
          result = u.map((_) => {
            return {
              type: 'gift',
              item: item.item,
              isViewable: item.isViewable,
              key: item.key,
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'promotion_activity',
              d: item?.item?.curIndex,
              iid: `activity_type=${item?.item?.typeDesc}&type=${platformMap[item?.item?.platform]?.[1]}&channel=${
                platformMap[item?.item?.platform]?.[0]
              }&activity_id=${item?.item?.actId}&group_id=${item?.item?.groupId}&next=product.${
                _.pid || 0
              }&u=${encodeURIComponent(_?.u)}`,
            };
          });
        }
        return result;
      },
    },
    getParse_coupon: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { pageName, traceObj } = args;
        if (Array.isArray(item.item) && item.item.length > 0) {
          const hasMemberQualifications = traceObj?.status === 2; // 判断是否是会员资格

          const result = item.item?.map((coupon) => {
            const data = coupon;
            const isMemberCoupon = data?.tags?.includes('proMember');
            const isApply = data?.useStatus === 'canUse';
            const isMiCoin = data?.type === 'coin';
            const diamondCardType = ['consumables_card', 'wearable_card', 'wearable_card'].some((tag) =>
              data?.tags?.includes(tag),
            ); // 是否是钻石卡
            const cantExchange = data.cantExchange >= 0 ? data.cantExchange : -1;
            const cantExchangeReason = data?.cantReason?.includes('coin')
              ? '立即去赚'
              : data?.cantReason?.includes('capacity')
              ? '等级不足'
              : '暂不可用';

            const status = isApply
              ? '适用商品'
              : isMiCoin
              ? cantExchange === 0
                ? '立即兑换'
                : cantExchangeReason
              : diamondCardType
              ? '开通领取'
              : hasMemberQualifications && isMemberCoupon
              ? '开通并领取'
              : '立即领取';

            // abtest 实验
            const testId = data?.abTest?.testId || '';
            const groupId = data?.abTest?.groupId || '';

            let u = '';
            if (data?.useStatus === 'canUse') {
              u = `https://m.mi.com/mfbs/mstd/joinmore?couponId=${data?.couponId}`;
            }
            // else if (diamondCardType) {
            //   const { envMode, pid, gid } = traceObj;
            //   const cardType = `&cardType=${diamondCardTypes[getDiamondCardType(data?.tags)].type}`;
            //   const _jumpFrom = `&_jumpFrom=${encodeURIComponent(
            //     `${Constants.tradeUrlPrefix}mfbs/mstd/product?${gid ? `goodsId=${gid}&` : ''}${
            //       pid ? `commodityId=${pid}` : ''
            //     }`,
            //   )}`;
            //   u =
            //     envMode === 0
            //       ? `https://m.mi.com/mfbs/dghd/m_universal?_rt=rn&pageid=16133&pdl=mishop&sign=0f135cf4f9529a6206f01be522fbcafa${cardType}${_jumpFrom}`
            //       : envMode === 2
            //       ? `https://pre.m.mi.com/mfbs/dghd/m_universal?_rt=rn&pageid=16133&pdl=mishop&sign=0f135cf4f9529a6206f01be522fbcafa${cardType}${_jumpFrom}`
            //       : `http://m.test.mi.com/mfbs/dghd/m_universal?_rt=rn&pageid=3152&pdl=mishop&sign=2bcf2b78d96e442c421b47beb7f0b71b${cardType}${_jumpFrom}`;
            // }
            const availableChannel = data.availableChannel;
            const getOnlineTag = (availableChannel) => {
              if ((availableChannel || []).includes('MISHOP') && (availableChannel || []).includes('MIHOME')) {
                return 'channel=' + encodeURIComponent('online&offline');
              } else if ((availableChannel || []).includes('MISHOP')) {
                return 'channel=' + encodeURIComponent('online');
              } else if ((availableChannel || []).includes('MIHOME')) {
                return 'channel=' + encodeURIComponent('offline');
              }
            };
            const tag = getOnlineTag(availableChannel);
            return {
              type: 'coupon',
              item: item.item,
              isViewable: item.isViewable,
              key: item.key,
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'coupon_button',
              d: data.statD,
              iid: `${tag ? tag + '&' : ''}coupon_id=${data?.couponId || ''}&type_id=${
                data?.typeId || ''
              }&coupon_status=${status}&coupon_type=${data?.customRuleDetails?.[0]?.desc}&u=${encodeURIComponent(
                u,
              )}&coupon_tags=${(data.tags || []).join(',')}&test_id=${testId}&group_id=${groupId}`,
            };
          });
          return result;
        }
      },
    },
  },
  'Prd.coupon.touch': {
    operation: ['TOUCH'],
    title: '优惠弹层活动点击',
    c: {
      type: 'constant',
      value: 'coupon_button',
    },
    d: {
      type: 'variable',
      func: ({ d }) => {
        return d;
      },
    },
    iid: {
      type: 'variable',
      func: ({ iid }) => {
        return iid;
      },
    },
  },
  'Prd.discount.modal.touch': {
    operation: ['TOUCH'],
    title: '优惠弹层活动点击',
    c: {
      type: 'constant',
      value: 'promotion_activity',
    },
    iid: {
      type: 'variable',
      func: ({ iid }) => {
        return iid;
      },
    },
  },
  'Prd.pour.popup': {
    operation: ['VISIBLE'],
    title: '天降灌券',
    c: {
      type: 'constant',
      value: 'pour_pop_up',
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        return `coupon_id=${traceData.couponId}&actId=${traceData.actId}`;
      },
    },
  },
  'Prd.award.popup': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '天降领券',
    c: {
      type: 'constant',
      value: 'award_pop_up',
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        return traceData?.couponId
          ? `coupon_id=${traceData.couponId}&pop_status=1&actId=${traceData.actId}`
          : `pop_status=0&actId=${traceData.actId}`;
      },
    },
  },
  'Prd.activity': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '活动楼层',
    c: {
      type: 'constant',
      value: 'activity',
    },
    iid: {
      type: 'variable',
      func: ({ activityType, u, actList }) => {
        const array = [];
        actList?.forEach((item) => {
          if (item.actType === 4 && !array.includes('installments')) {
            array.push('installments');
          } else if (item.actType === 2 && !array.includes('define')) {
            array.push('define');
          } else if (item.actType === 1 && array.every((item) => item.indexOf('exchange') < 0)) {
            array.push('exchange_' + item.subActs?.[0]?.actId);
          }
        });
        return `${
          array.length ? `mode=${encodeURIComponent(array.join('&'))}&` : ''
        }activity_type=${activityType}&u=${encodeURIComponent(u)}`;
      },
    },
  },
  'Prd.giftmodal.confirm': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '赠品弹层确定按钮',
    c: {
      type: 'constant',
      value: 'purchase',
    },
    iid: {
      type: 'variable',
      func: ({ selected, curShipment }) => {
        const map = {
          depot: 'express',
          store_pickup: 'pickup',
          store_flash: 'takeup',
        };
        const skus = Object.keys(selected)
          ?.map((sku) => {
            return sku?.split('_')[0] || '';
          })
          ?.join(',');
        return `delivery=${map[curShipment] || ''}&skus=${skus}&type=sheet_gift`;
      },
    },
  },
  'Prd.activity.modal': {
    operation: ['visible'],
    getParse: {
      type: 'variable',
      func(item, data, { pageName }) {
        if (item?.item?.actType == 1) {
          return;
        }
        const c = {
          4: 'activity_installments',
          1: 'activity_exchange',
          3: 'activity_define',
        };
        const iid = () => {
          if (item?.item?.actType == 4) {
            let type = '';
            const tags = item?.item?.tags || [];
            if (tags?.length === 2) {
              type = '分期免息+立减';
            } else if (tags?.length === 1 && tags?.[0] === 'reduce') {
              type = '分期立减';
            } else if (tags?.length === 1 && tags?.[0] === 'rateFee') {
              type = '分期免息';
            }
            return `type=${type}`;
          } else if (item?.item?.actType == 3) {
            return `activity_id=${item?.item?.id || ''}&u=${
              item?.item?.jump ? encodeURIComponent(item?.item?.jump) : ''
            }`;
          }
        };
        return [
          {
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            d: 1,
            c: c[item?.item?.actType],
            iid: iid(),
          },
        ];
      },
    },
  },
  'Prd.activity.installments': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'activity_installments',
    },
    iid: {
      type: 'variable',
      func: ({ tags }) => {
        let type = '';
        if (tags?.length === 2) {
          type = '分期免息+立减';
        } else if (tags?.length === 1 && tags?.[0] === 'reduce') {
          type = '分期立减';
        } else if (tags?.length === 1 && tags?.[0] === 'rateFee') {
          type = '分期免息';
        }
        return `type=${type}`;
      },
    },
  },
  'Prd.activity.define': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'activity_define',
    },
    iid: {
      type: 'variable',
      func: ({ activity_id, u }) => {
        return `activity_id=${activity_id}&u=${u}`;
      },
    },
  },
  'Prd.activity.exchange': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'activity_exchange',
    },
    d: {
      type: 'variable',
      func: ({ d }) => {
        return d;
      },
    },
    iid: {
      type: 'variable',
      func: ({ next, u }) => {
        return `next=${next}&u=${u}`;
      },
    },
  },
  'Prd.match.product': {
    operation: ['visible'],
    getParse: {
      type: 'variable',
      func(item, data, { pageName }) {
        return [
          {
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            d: item?.index + 1,
            c: 'product',
            iid: `type=makeup&next=product.${item?.item?.goodsId || item?.item?.goodsList?.[0]?.goodsId}`,
          },
        ];
      },
    },
  },
  'Prd.middle.recommend': {
    operation: ['visible'],
    getParse: {
      type: 'variable',
      func(item, data, { pageName }) {
        return [
          {
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            d: item?.index + 1,
            c: 'sug',
            scmv2: item?.item?.scm,
            iid: `next=product.${item?.item?.pid}&u=${encodeURIComponent(
              'https://m.mi.com/mfbs/mstd/product?commodityId=' + item?.item?.pid,
            )}`,
          },
        ];
      },
    },
  },
  'Prd.matchshopping.product': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'product',
    },
    d: {
      type: 'variable',
      func: ({ d }) => {
        return d;
      },
    },
    iid: {
      type: 'variable',
      func: ({ next, u }) => {
        return `next=product.${next}&type=makeup&u=${u}`;
      },
    },
  },
  'Prd.matchshopping.select': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'select',
    },
    d: {
      type: 'variable',
      func: ({ d }) => {
        return d;
      },
    },
    iid: {
      type: 'variable',
      func: ({ next, status }) => {
        return `next=product.${next}&status=${status}`;
      },
    },
  },
  'Prd.matchshopping.addcart': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'addcart',
    },
    iid: {
      type: 'variable',
      func: ({ skus }) => {
        return `skus=${skus}&type=makeup`;
      },
    },
  },
  'Prd.matchshopping.modal': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'makeup',
    },
  },
  'Prd.banner': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'banner',
    },
    d: {
      type: 'variable',
      func: ({ d }) => {
        return d;
      },
    },
  },
  'Prd.middle.recommend.touch': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'sug',
    },
    d: {
      type: 'variable',
      func: ({ d }) => {
        return d;
      },
    },
    iid: {
      type: 'variable',
      func: ({ next }) => {
        return `next=product.${next}&u=${encodeURIComponent('https://m.mi.com/mfbs/mstd/product?commodityId=' + next)}`;
      },
    },
  },
  'Prd.old.new': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'old_for_new',
    },
    iid: {
      type: 'variable',
      func: ({ trade_in_model }) => {
        return `trade_in_model=${trade_in_model}`;
      },
    },
  },
  'Prd.address.flashstore': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: 'store_takeup',
    },
    iid: {
      type: 'variable',
      func: ({ orgId }) => `org_id=${orgId}`,
    },
  },
  'Prd.address.flashstore_visible': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'store_takeup',
    },
    iid: {
      type: 'variable',
      func: ({ orgId }) => `org_id=${orgId}`,
    },
  },
  'Prd.address.pickup_store_visible': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'store_pickup',
    },
    iid: {
      type: 'variable',
      func: ({ orgId }) => `org_id=${orgId}`,
    },
  },
  'Prd.address.pickup_store': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: 'store_pickup',
    },
    iid: {
      type: 'variable',
      func: ({ orgId }) => `org_id=${orgId}`,
    },
  },
  'Prd.address.location_takeup': {
    operation: ['VISIBLE', 'Touch'],
    c: {
      type: 'constant',
      value: 'location_takeup',
    },
  },
  'Prd.address.location_pickup': {
    operation: ['VISIBLE', 'Touch'],
    c: {
      type: 'constant',
      value: 'location_pickup',
    },
  },
  'Prd.storemodal.store1': {
    operation: ['VISIBLE', 'Touch'],
    c: {
      type: 'constant',
      value: 'store',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return 1;
      }`,
    },
  },
  'Prd.storemodal.store2': {
    operation: ['VISIBLE', 'Touch'],
    c: {
      type: 'constant',
      value: 'store',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return 2;
      }`,
    },
  },
  'Prd.main.storelist_tab': {
    operation: ['VISIBLE', 'Touch'],
    title: '店铺列表tab',
    c: {
      type: 'constant',
      value: 'store_conditions',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData.d;
      },
    },
  },
  'Prd.floor.choose_delivery1': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: 'choose_delivery',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return 1;
      }`,
    },
  },
  'Prd.floor.choose_delivery2': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: 'choose_delivery',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return 2;
      }`,
    },
  },
  'Prd.floor.choose_delivery3': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: 'choose_delivery',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return 3;
      }`,
    },
  },
  'Prd.sku.customize': {
    operation: ['Touch', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'specification_design',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
  },
  'Prd.sku.customize2': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: 'specification_design',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
  },
  'Prd.customize.close': {
    operation: ['Touch', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'off_design',
    },
  },
  'Prd.customize.images': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'design_perspective',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
  },
  'Prd.customize.carousel': {
    operation: ['Touch', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'design_carousel',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
  },
  'Prd.customize.carousel.visible': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'design_carousel',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
  },
  'Prd.customize.tab': {
    operation: ['Touch', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'design_tab',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
  },
  'Prd.customize.tab_select': {
    operation: ['Touch', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'design_choose',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
  },
  'Prd.customize.design_progress': {
    operation: ['Touch', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'design_progress',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
  },
  'Prd.customize.design_result_carousel': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'design_result_carousel',
    },
  },
  'Prd.customize.design_result_carousel.visible': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'design_result_carousel',
    },
  },
  'Prd.customize.redesign': {
    operation: ['Touch', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'redesign',
    },
  },
  'Prd.customize.confirm_design': {
    operation: ['Touch', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'confirm_design',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `skus=${traceData.skus}`;
      },
    },
  },
  'Prd.customize.design_type': {
    operation: ['Touch', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'design_type',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
  },
  'Prd.customize.design_3d.visible': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'design_3d',
    },
  },
  'Prd.customize.design_3d.touch': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: 'design_3d',
    },
  },
  'Prd.payments.payment': {
    operation: ['Touch', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'payment',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `payment_discounts=${traceData.type}`;
      },
    },
  },
  'Prd.bottom.govBtn': {
    operation: ['Touch', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'state_subsidies',
    },
  },
};

export default Config;
